module.exports = __webpack_public_path__ + "static/media/AdUnitStep1.b072ddc2.svg";